<template>
    <v-flex xs12>
        <v-layout row wrap class="businesses__filters active">
            <v-flex>
                <v-menu v-show="filters.establishments.length > 0" attach v-model="showEstablishments" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" id="establishment_fiterBtn" data-qe-id="establishment_fiterBtn">
                            {{assetSummaryConstants.ESTABLISHMENT}}
                            <i class="material-icons">arrow_drop_down</i> 
                        </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-list-tile v-for="(item, index) in assetSummaryConstants.establishmentTypes" 
                                :key="index"
                                :disabled="checkDisabled('establishments',item)"
                                @click.stop="toggleColor('establishments',item)">
                                {{item}}
                                <v-checkbox :data-qe-id="'establishmentTypeFilter_chk'+index"
                                    multiple
                                    v-model="filters.establishments"
                                    :value="item"
                                    :disabled="checkDisabled('establishments',item)"
                                    @click.stop="toggleColor('establishments',item)"
                                    color="$ypo_blue" hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
                <v-menu attach v-show="filters.cuisineTypes.length > 0" v-model="showCuisinetypes" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" id="cuisine_fiterBtn" data-qe-id="cuisine_fiterBtn">
                            {{businessesConstants.CUISINE_CATAGORY}} <i class="material-icons">arrow_drop_down</i>
                            </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-flex class="businesses-options__list-body inner-scrollbar">
                            <v-list-tile v-for="(item, index) in assetSummaryConstants.cuisineTypes" 
                                :key="index" 
                                :disabled="checkDisabledForCuisine('cuisineTypes',item)"
                                @click.stop="toggleColor('cuisineTypes',item)">
                                {{item}}
                                <v-checkbox 
                                    :data-qe-id="'cuisineFilter_chk'+index" 
                                    color="$ypo_blue"
                                    multiple
                                    v-model="filters.cuisineTypes"
                                    :value="item"
                                    :disabled="checkDisabledForCuisine('cuisineTypes',item)"
                                    @click.stop="toggleColor('cuisineTypes',item)" 
                                    hide-details>
                                </v-checkbox>
                            </v-list-tile>
                            </v-flex>
                        </v-list>
                    </v-flex>
                </v-menu>
                <v-menu attach v-show="filters.accommodationTypes.length > 0" v-model="showAccommodationtypes" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" data-qe-id="accommodation_fiterBtn">
                            {{assetSummaryConstants.ACCOMODATION}} <i class="material-icons">arrow_drop_down</i>
                            </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-list-tile v-for="(item, index) in assetSummaryConstants.accommodationTypes" 
                                :key="index"
                                :disabled="checkDisabled('accommodationTypes',item)" 
                                @click.stop="toggleColor('accommodationTypes',item)">
                                {{item}}
                                <v-checkbox 
                                    :data-qe-id="'accommodationFilter_chk'+index" 
                                    color="$ypo_blue"
                                    multiple
                                    v-model="filters.accommodationTypes"
                                    :value="item" 
                                    :disabled="checkDisabled('accommodationTypes',item)" 
                                    @click.stop="toggleColor('accommodationTypes',item)"
                                    hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
                <v-menu attach v-show="filters.prices.length > 0" v-model="showPrices" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" data-qe-id="price_fiterBtn">
                            {{businessesConstants.PRICE}} <i class="material-icons">arrow_drop_down</i>
                            </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-list-tile v-for="(item, index) in assetSummaryConstants.priceRange" 
                                :key="index"
                                :disabled="checkDisabled('prices',item)"  
                                @click.stop="toggleColor('prices',item)">
                                {{item}}
                                <v-checkbox 
                                    :data-qe-id="'priceFilter_chk'+index"
                                    multiple
                                    v-model="filters.prices"
                                    :value="item"
                                    :disabled="checkDisabled('prices',item)"
                                    @click.stop="toggleColor('prices',item)"
                                    color="$ypo_blue" 
                                    hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
                <v-menu attach v-show="filters.hotelClassTypes.length > 0" v-model="showHotelclassTypes" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" data-qe-id="hotelclass_fiterBtn">
                            {{assetSummaryConstants.HOTEL_CLASS}} <i class="material-icons">arrow_drop_down</i>
                            </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-list-tile v-for="(item, index) in assetSummaryConstants.hotelClass" 
                                :key="index"
                                :disabled="checkDisabled('hotelClassTypes',item)" 
                                @click.stop="toggleColor('hotelClassTypes',item)">
                                {{item}}
                                <v-checkbox 
                                    :data-qe-id="'hotelClassFilter_chk'+index" 
                                    color="$ypo_blue" 
                                    multiple
                                    v-model="filters.hotelClassTypes"
                                    :value="item"
                                    :disabled="checkDisabled('hotelClassTypes',item)"
                                    @click.stop="toggleColor('hotelClassTypes',item)"
                                    hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
                <v-menu attach v-show="filters.starRatings.length > 0" v-model="showStarratings" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" data-qe-id="starrating_fiterBtn">
                            {{assetSummaryConstants.STAR_RATING}} <i class="material-icons">arrow_drop_down</i>
                            </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-list-tile v-for="(item, index) in [1,2,3,4,5]" 
                                :key="item"
                                :disabled="checkDisabled('starRatings',item)"
                                @click.stop="toggleColor('starRatings',item)">
                                <v-flex v-for="i in item" :key="i" class="stars">
                                    <v-icon :disabled="checkDisabled('starRatings',item)" color="$ypo_blue">star</v-icon>
                                </v-flex>
                                <v-checkbox 
                                    :data-qe-id="'starratingFilter_chk'+index" 
                                    color="$ypo_blue" 
                                    multiple
                                    v-model="filters.starRatings"
                                    :value="item"
                                    :disabled="checkDisabled('starRatings',item)" 
                                    @click.stop="toggleColor('starRatings',item)"
                                    hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
                <v-menu attach v-show="filters.distances.length > 0" v-model="showDistances" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" data-qe-id="distance_fiterBtn">
                            {{businessesConstants.DISTANCE}}({{distanceSwitch? businessesConstants.MILES: businessesConstants.KILOMETERS }})<i class="material-icons">arrow_drop_down</i>
                            </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-list-tile v-for="(item, index) in [1,2,5,10,25]" 
                                :key="item"
                                :disabled="checkDisabled('distances',item)"
                                @click.stop="toggleColor('distances',item)">
                                {{item}}
                                <v-checkbox 
                                    :data-qe-id="'distanceFilter_chk'+index" 
                                    color="$ypo_blue" 
                                    multiple
                                    v-model="filters.distances"
                                    :value="item"
                                    :disabled="checkDisabled('distances',item)" 
                                    @click.stop="toggleColor('distances',item)"
                                    hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
            </v-flex>
        </v-layout>
        <!-- <v-layout row wrap class="businesses__filters">
            <v-flex xs12 sm4>
                <v-menu attach v-show="filters.ownershipTypes.length > 0" v-model="showOwnershipTypes" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" id="establishment_fiterBtn" data-qe-id="establishment_fiterBtn">
                            <i v-if="!showOwnershipTypes" class="fas fa-plus-square"></i>
                            <i v-if="showOwnershipTypes" class="fas fa-minus-square"></i>  
                            {{businessesConstants.OWNERSHIP_TYPE}}
                        </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-subheader>{{businessesConstants.REFINE_BY}}{{businessesConstants.OWNERSHIP_TYPE}}</v-subheader>
                            <v-list-tile v-for="(item, index) in businessesConstants.OWNERSHIP_TYPES" 
                                :key="index"
                                :disabled="checkDisabledForOwnertype('ownershipTypes',item)"
                                @click.stop="toggleColor('ownershipTypes',item)">
                                {{item}}
                                <v-checkbox :data-qe-id="'ownershipTypeFilter_chk'+index"
                                    multiple
                                    v-model="filters.ownershipTypes"
                                    :value="item"
                                    :disabled="checkDisabledForOwnertype('ownershipTypes',item)"
                                    @click.stop="toggleColor('ownershipTypes',item)"
                                    color="$ypo_blue" hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
            </v-flex>
        </v-layout> -->
    </v-flex>
</template>

<script>
    import { businessesConstants, filterMethods, emptyFilters } from './businesses.constants';
    import { assetSummaryConstants } from '../MemberProfile/memberProfile.constants';

    export default {
        name: "BusinessActiveFilters",
        data() {
            return {
                assetSummaryConstants,
                businessesConstants,
                showEstablishments: false,
                showCuisinetypes: false,
                showAccommodationtypes: false,
                showStarratings: false,
                showPrices: false,
                showHotelclassTypes: false,
                showOwnershipTypes: false,
                showDistances: false,
                filters: emptyFilters,
            };
        },
        props: {
            filtersEnabled: {
                type: Object,
                required: false,
            },
            distanceSwitch: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            ...filterMethods,
            setActiveFilters(filters) {
                this.filters = filters;
            },
        },
        watch: {
            filters: {
                handler(newval) {
                    this.$emit('filters', newval);
                },
                deep: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .businesses {
        &__filters {
            &.active {
                .businesses-options {
                    margin: 0px;
                }
            }
        }
    }
</style>
